import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getForwarders, Source } from '../../api';

export interface ForwardersState {
	data: Source[];
	error: boolean;
	loading: boolean;
}

export const initialState: ForwardersState = {
	data: [],
	error: false,
	loading: true
};

export const fetchForwarders = createAsyncThunk('forwarders/fetchAll', getForwarders);

export const forwardersSlice = createSlice({
	name: 'sources',
	initialState,
	reducers: {
		forwardersAction: (state, action: PayloadAction<Partial<ForwardersState>>) => {
			state = {
				...state,
				...action.payload
			};
		}
	},
	extraReducers: builder => {
		builder.addCase(fetchForwarders.pending, state => {
			state.data = [];
			state.error = false;
			state.loading = true;
		});

		builder.addCase(fetchForwarders.fulfilled, (state, action) => {
			state.data = action.payload;
			state.error = false;
			state.loading = false;
		});

		builder.addCase(fetchForwarders.rejected, state => {
			state.error = true;
			state.loading = false;
		});
	}
});

export const { forwardersAction } = forwardersSlice.actions;
export const forwardersReducer = forwardersSlice.reducer;
